import { CropsState } from '../actions/crops/types/state';
import { CropAction, CropActions } from '../actions/cropActions';

export const initialState: CropsState = {};

function cropReducer(
  state = initialState,
  action: CropActions
): CropsState {
  switch (action.type) {
    case CropAction.ReceiveCropList:
      return {
        ...state,
        ...action.cropList,
      };

    case CropAction.ReceiveCustomCropNominalWeights: {
      const customCrops = action.harvestMetadata.reduce(
        (_customCrops, season) => {
          const { nominalWeight, seasonTag } = season;
          const [, cropCode] = seasonTag.split(':');

          return {
            ..._customCrops,
            [cropCode]: {
              ...state[cropCode],
              customNominalWeight: nominalWeight,
            },
          };
        },
        {}
      );

      return {
        ...state,
        ...customCrops,
      };
    }

    default:
      return state;
  }
}

export default cropReducer;
